import * as types from 'constants/actionTypes';

// Helper function to create action objects more efficiently
const createAction = (type, payload = {}) => ({ type, ...payload });

export const logout = () => createAction(types.LOGOUT_REQUEST);

export const openDialogChangePassword = () => createAction(types.OPEN_CHANGEPASSWORD_DIALOG);

export const closeDialogChangePassword = () => createAction(types.CLOSE_CHANGEPASSWORD_DIALOG);

export const showError = (message, compName, modal = false) => createAction(types.DIALOG_ALERT_OPEN, { message, compName, modal });

export const updatePriceMatchRows = (modal) => createAction(types.UPDATE_PRICE_MATCH_PRODUCT, { modal });

export const removePriceMatchRows = (modal) => createAction(types.REMOVE_PRICE_MATCH_PRODUCT, { modal });

export const showSnackbar = (message) => createAction(types.SNACKBAR_SHOW_MESSAGE, { message });

export const showLoadingSpinner = () => createAction(types.SHOW_LOADING);

export const hideLoadingSpinner = () => createAction(types.HIDE_LOADING);

export const setBranchContext = (branchId) => createAction(types.SET_BRANCH_CONTEXT, { branchId });

export const getUserBranches = (userName) => createAction(types.GET_USER_BRANCHES, { userName });

export const changeBranch = () => createAction(types.CHANGE_USER_BRANCH);

export const getStores = () => createAction(types.STORE_GET_ALL);

export const changeStore = () => createAction(types.CHANGE_STORE);

export const selectStore = () => createAction(types.SELECT_STORE);

export const getApplicationSetting = (branchId) => createAction(types.GET_APPLICATION_SETTING, { branchId });

// CHECKIN
export const handleCheckInDialog = () => createAction(types.HANDLE_CHECKIN_DIALOG);

export const hideLoading = () => createAction("HIDDEN-LOADING");